class GiftSelector extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.gwp-cart-bogof__offer-selector');
    this.cards = this.querySelectorAll('.bogof-card');
    this.offersAvailable = parseInt(this.dataset.allGifts, 10); // Convert to number
    this.position = this.querySelector('.position')
    this.initialiseGiftSelector();
  }

  initialiseGiftSelector() {

    // eslint-disable-next-line eqeqeq
    if (this.offersAvailable == 1) return

    this.trigger.addEventListener('click', () => {
      this.handleClick();
    });
  }

  handleClick() {
    const currentCard = this.querySelector('.bogof-card--visible');
    const currentCardIndex = parseInt(currentCard.dataset.index, 10); // Convert to number

    // Remove visibility from all cards
    this.cards.forEach(card => {
      card.classList.remove('bogof-card--visible');
    });

    // Calculate the next index
    const nextIndex = (currentCardIndex + 1) % this.offersAvailable; // Cycle back to 0 if at the last card
    this.getNextCard(nextIndex);
  }

  getNextCard(nextIndex) {
    const nextCard = this.querySelector(`[data-index="${nextIndex}"]`);
    if (nextCard) {
      nextCard.classList.add('bogof-card--visible'); // Make the next card visible
      this.position.textContent = `${nextIndex + 1}`
    } else {
      console.error(`No card found with data-index="${nextIndex}"`);
    }
  }
}

customElements.define('gift-selector', GiftSelector);